import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/gei/auxiliaries/levels/level2/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/gei/auxiliaries/levels/level2/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/gei/auxiliaries/levels/level2/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/gei/auxiliaries/levels/level2/create`,  data)
    },
    update(data) {
        return axios.post(`/gei/auxiliaries/levels/level2/update`,  data)
    },
    delete(id) {
        return axios.delete(`/gei/auxiliaries/levels/level2/delete/${id}`)
    },
}